import {Field, Formik, FormikHelpers as FormikActions} from 'formik';
import React, {useState} from 'react';
import PasswordChecklist from 'react-password-checklist';
import * as Yup from 'yup';
import {Button} from '~/components/Button';
import {InputType} from '~/components/Controls/Input';
import {Form, FormColumn, FormControls, FormRow, FormTitle, InputField, IntentText} from '~/components/Form';
import {IModalComponent, IModalComponentClose} from '~/components/Modal';
import {Intent} from '~/lib/intent';
import style from '~/modules/Profile/views/index.scss';
import {passwordSchema} from '~/modules/Profile/views/RecoveryView/RenewView';

interface IChangePassword {
    password: string;
    current: string;
}

interface IChangePasswordFormProps {
    passwords: IChangePassword;
    onSubmit?: (values: IChangePassword, formikActions: FormikActions<IChangePassword>, close: IModalComponentClose) => void;
}

export const ChangePasswordForm: IModalComponent<IChangePasswordFormProps> = props => {
    const [isPasswordValid, setIsPasswordValid] = useState<boolean>(false);


    return (<Formik initialValues={props.passwords}
        validationSchema={Yup.object().shape<IChangePassword>({
            current: null,
            password: passwordSchema,
        })}
        onSubmit={(changePassword, actions) => props.onSubmit(changePassword, actions, props.close)}
    >{({status, isSubmitting, values}) =>
            <Form>
                <FormTitle>Change password</FormTitle>
                {status && <IntentText intent={Intent.DANGER}>{status}</IntentText>}
                <FormRow>
                    <FormColumn>
                        <PasswordChecklist
                            rules={['minLength', 'lowercase', 'capital', 'number', 'specialChar']}
                            minLength={8}
                            value={values.password ?? ''}
                            onChange={isValid => setIsPasswordValid(isValid)}
                        />
                    </FormColumn>
                    <FormColumn>
                        <Field name='current'
                            label='Current'
                            options={{
                                placeholder: 'password',
                                disabled: isSubmitting,
                                type: InputType.PASSWORD,
                                passwordToggle: true,
                                autoComplete: 'current-password',
                            }}
                            component={InputField}
                        />
                        <Field name='password'
                            label='New'
                            options={{
                                placeholder: 'password',
                                disabled: isSubmitting,
                                type: InputType.PASSWORD,
                                passwordToggle: true,
                                autoComplete: 'new-password',
                            }}
                            component={InputField}
                        />
                    </FormColumn>
                </FormRow>
                <FormControls>
                    <Button disabled={isSubmitting}
                        onClick={props.close}
                    >Cancel</Button>
                    <Button type='submit'
                        disabled={isSubmitting || !isPasswordValid}
                        intent={Intent.PRIMARY}
                        rightIcon={isSubmitting && <i className='fa fa-spinner fa-spin'/>}
                    >Change</Button>
                </FormControls>
            </Form>}
    </Formik>);
};
